const reasons = [
  {
    icon: 'ri-search-eye-line',
    title: 'Диагностика до обучения',
    desc: 'Сначала разбираемся, какие управленческие проблемы действительно существуют в компании: как руководители ставят задачи, делегируют, контролируют, дают обратную связь.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Реальные кейсы',
    desc: 'Работаем с реальными задачами участников и управленческими ситуациями компании. Не абстрактные примеры из учебников, а конкретные задачи ваших руководителей.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Практика',
    desc: 'Инструменты делегирования и постановки задач отрабатываются в упражнениях, ролевых ситуациях и кейсах. Теория — только основа для практической отработки.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Адаптация',
    desc: 'Программа корректируется под специфику компании и уровень руководителей. Содержание, примеры и акценты настраиваются под реальный контекст.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Сопровождение',
    desc: 'После обучения при необходимости продолжается работа с командой: разбор реальных ситуаций, поддержка внедрения, ответы на вопросы.',
  },
  {
    icon: 'ri-file-copy-2-line',
    title: 'Систематизация',
    desc: 'Компания может получить алгоритмы, чек-листы и другие инструменты для дальнейшего использования руководителями в ежедневной практике.',
  },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Почему обучение не заканчивается тренингом, а приводит к реальным изменениям в управленческой практике
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r) => (
            <div key={r.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${r.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{r.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Наша задача — не провести ещё один тренинг, а помочь руководителям применять инструменты делегирования и постановки задач в реальной работе.
          </p>
        </div>
      </div>
    </section>
  );
}